import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchSuccessFactor, updateInformationCapitalGoal } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function InfoCapitalGoalDataEditPage() {
  const { businessDomainId, successFactorId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [form, setForm] = useState({ successFactorId: "", businessDomainId: "", successFactorName: "", successFactorDescription: "" });
  useEffect(() => {
    (async () => {
      try {
        const d = await fetchSuccessFactor(successFactorId);
        setForm({ successFactorId: d.successFactorId || "", businessDomainId: d.businessDomainId || "", successFactorName: d.successFactorName || "", successFactorDescription: d.successFactorDescription || "" });
      } catch (e) { notify.apiError(e); }
    })();
  }, [successFactorId]);
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = async (e) => {
    e.preventDefault();
    try { await updateInformationCapitalGoal(form); notify.success(t("message.update.success")); navigate(`/strategy/${businessDomainId}/info-capital-goals-data/${successFactorId}`); }
    catch (err) { notify.apiError(err); }
  };
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("infoCapitalGoalData.edit.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}><TextField fullWidth required label={t("successFactor.name")} name="successFactorName" value={form.successFactorName} onChange={handleChange} /></Grid>
          <Grid item xs={12}><TextField fullWidth multiline rows={3} label={t("common.description")} name="successFactorDescription" value={form.successFactorDescription} onChange={handleChange} /></Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/info-capital-goals-data/${successFactorId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
